<template>
  <div class="full-page" :class="{ 'nav-open': false }">
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <notifications></notifications>
      <div class="page-header header-filter" filter-color="black">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
//   computed: {
//     setPageClass() {
//       return `${this.$route.name}-page`.toLowerCase();
//     }
//   },
  methods: {
    toggleSidebarPage() {
      // if (this.$sidebar.showSidebar) {
      //   this.$sidebar.displaySidebar(false);
      // }
    }
  }
};
</script>